// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.feedclaims.RentalManagerUserFeedClaimsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerUserFeedClaimRequestType } from '../..';

interface RequestParams {
  companyName?: string;
  email?: string;
  feedOrCompanyId?: string;
  feedProviderName?: string;
  fullAddress?: string;
  note?: string;
  requestType: RentalManagerUserFeedClaimRequestType;
  unitNumber?: string;
}

export const RentalManagerUserFeedClaimsWebApiHandler_request_Path = '/api/web/v1/users/feedClaims/request';

/**
 * Create a claim feed listing request
 * @deprecated
 */
export const RentalManagerUserFeedClaimsWebApiHandler_request = (getParams: RequestParams, client = getClient()) => {
  return httpFrontEndRequest<RequestParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFeedClaimsWebApiHandler_request_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
